import { z } from 'zod';

export const ErrorPayload = z.object({
  errorCode: z.string(),
  errorReason: z.string(),
});

export type ErrorPayload = z.infer<typeof ErrorPayload>;

export const ResponseStatus = z
  .object({
    response: z.object({
      status: z.number(),
    }),
  })
  .transform((error) => error.response.status);
